import { render, staticRenderFns } from "@/templates/serviceDelivery/sdPending.html?vue&type=template&id=4b4bd50c&"
import script from "./SDPending.vue?vue&type=script&lang=js&"
export * from "./SDPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports